import React, { useState, ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from 'layouts/member/Layout';
import SubmitButton from 'components/SubmitButton';
import { IconChevronLeft, IconClose } from 'components/Svg';
import sample1 from 'assets/common/images/sample1.jpg';
import sample2 from 'assets/common/images/sample2.jpg';
import sample3 from 'assets/common/images/sample3.jpg';
import CheckBox from 'components/CheckBox';

const Rescue: React.FC = () => {
  const navigate = useNavigate();
  const [notes, setNotes] = useState('');

  // Static data for demo
  const formData = {
    location: '店内・室内',
    part: '蛇口（単水栓）',
    status: 'その他',
    statusDetail: '部品が破損して水漏れが発生しているようです。現在水栓を止めた上で、破損部分をテープで保護しています。',
    estimate: '止水応急処置、パッキン類交換、器具交換',
    price: '8,000円～',
  };
  const images = [
    { label: 'トラブル発生場所', src: sample1 },
    { label: '現在の状況', src: sample2 },
    { label: '店舗外観', src: sample3 },
  ];
  const registration = {
    memberNo: '19045138',
    memberId: 'izumi02',
    name: '泉 良直',
    company: 'ダブルウィンシステム株式会社',
    address: '〒130-0026 東京都 墨田区 両国3-25-5 JE両国ビル 2F',
    phone: '08035205735',
    email: 'springsim24@i.softbank.jp',
    managerEmail: 'springsim24-manager@i.softbank.jp',
    billing: {
      company: 'ダブルウィンシステム株式会社',
      person: '鈴木 次郎',
      address: '〒130-0026 東京都 墨田区 両国3-25-5 JE両国ビル 2F',
      phone: '08035205735',
      method: '定額レスキュー登録',
    }
  };

  const handleSubmit = () => {
    // submit logic
    alert('送信しました');
  };

  return (
    <Layout>
      <div className="p-4">
        {/* Header: 最上位階層のみtitleとicon */}
        <div className="flex items-center justify-between">
          <button className="p-2" onClick={() => navigate(-1)}>
            <IconChevronLeft />
          </button>
          <div className="flex flex-col items-center flex-1">
            <span className="text-lg font-medium text-gray-900">水回り</span>
          </div>
          <button className="p-2" onClick={() => navigate('/')}>
            <IconClose />
          </button>
        </div>

        {/* Content */}
        <main className="flex-1 px-4 py-2 overflow-auto">
          <p className="my-4 text-sm text-gray-700">
            入力した内容は以下の通りです。<br />
            内容を確認後、利用規約に同意の上「送信する」ボタンを押してください。<br />
            送信後は担当者から折り返しの電話が来ますので、そのままお待ちください
          </p>
          {/* Form fields */}
          <div className="space-y-4 text-sm text-gray-800">
            <div className="mb-2 text-base font-semibold text-gray-700">依頼内容</div>
            <div>
              <label className="block mb-1 text-gray-500">トラブルの発生場所</label>
              <input type="text" readOnly value={formData.location} className="w-full p-2 bg-white border border-gray-300 rounded-lg"/>
            </div>
            <div>
              <label className="block mb-1 text-gray-500">故障箇所</label>
              <input type="text" readOnly value={formData.part} className="w-full p-2 bg-white border border-gray-300 rounded-lg"/>
            </div>
            <div>
              <label className="block mb-1 text-gray-500">故障状態</label>
              <input type="text" readOnly value={formData.status} className="w-full p-2 bg-white border border-gray-300 rounded-lg"/>
              <textarea readOnly value={formData.statusDetail} rows={3} className="w-full p-2 mt-2 bg-white border border-gray-300 rounded-lg" />
            </div>
          </div>

          {/* Estimate summary */}
          <div className="p-4 mt-6 bg-white shadow rounded-2xl">
            <div className="mb-1 text-sm text-gray-600">予想対応内容</div>
            <div className="text-base text-gray-800">{formData.estimate}</div>
            <div className="mt-1 font-bold text-blue-600">{formData.price}</div>
          </div>

          {/* Images */}
          <div className="mt-6 space-y-4">
            <div className="mb-2 text-base font-semibold text-gray-700">状況写真</div>
            {images.map((img, i) => (
              <div key={i} className="">
                <div className="mb-1 text-sm text-gray-500">{img.label}</div>
                <div className="overflow-hidden bg-gray-100 rounded-lg">
                  <img
                    src={img.src}
                    alt={img.label}
                    className="object-contain w-full h-auto max-h-80"
                    style={{ background: '#f3f4f6' }}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Notes */}
          <div className="mt-6">
            <label className="block mb-1 text-sm text-gray-500">備考（任意）</label>
            <textarea
              placeholder="依頼する上で伝えておきたいことなど、必要な場合のみご入力ください"
              value={notes}
              onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setNotes(e.target.value)}
              rows={4}
              className="w-full p-2 bg-white border border-gray-300 rounded-lg"
            />
          </div>

          {/* Registration info */}
          <div className="p-4 mt-6 text-sm text-gray-800 bg-white shadow rounded-2xl">
            <div className="mb-2 font-medium text-gray-600">ご登録情報</div>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              <div>
                <dt className="mb-1 text-gray-500">会員NO</dt>
                <dd className="font-semibold">{registration.memberNo}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">登録ID</dt>
                <dd className="font-semibold">{registration.memberId}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">ご担当者名</dt>
                <dd className="font-semibold">{registration.name}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">店舗名</dt>
                <dd className="font-semibold">{registration.company}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">店舗住所</dt>
                <dd className="font-semibold">{registration.address}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">電話番号</dt>
                <dd className="font-semibold">{registration.phone}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">メールアドレス</dt>
                <dd className="font-semibold">{registration.email}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">管理者メールアドレス</dt>
                <dd className="font-semibold">{registration.managerEmail}</dd>
              </div>
            </dl>
            <hr className="my-4 border-gray-200" />
            <div className="mb-2 font-medium text-gray-600">請求先情報</div>
            <dl className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
              <div>
                <dt className="mb-1 text-gray-500">会社名</dt>
                <dd className="font-semibold">{registration.billing.company}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">お名前</dt>
                <dd className="font-semibold">{registration.billing.person}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">住所</dt>
                <dd className="font-semibold">{registration.billing.address}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">電話番号</dt>
                <dd className="font-semibold">{registration.billing.phone}</dd>
              </div>
              <div>
                <dt className="mb-1 text-gray-500">決済方法</dt>
                <dd className="font-semibold">{registration.billing.method}</dd>
              </div>
            </dl>
          </div>
        </main>

        <div className="px-4 py-6 shadow-top">
          <div className="flex flex-col items-center mb-2 text-sm">
            <div className="flex flex-col items-center mb-4">
              <CheckBox
                id="agree"
                name="agree"
              >
                こちらの
                <a href="#" className="text-blue-600 underline transition-colors duration-150 hover:text-blue-800">利用規約</a>
                に同意します
              </CheckBox>
            </div>
            <div className="flex justify-center w-full">
              <SubmitButton onClick={handleSubmit}>
                送信する
              </SubmitButton>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Rescue;